<template>
    <div>
        <el-dialog :visible.sync="show" @close="close" width="40%">
            <span slot="title">
                <div class="flex justify-between">
                    <span>{{
                        $t('form.label.notification.alertSettings')
                    }}</span>
                </div>
            </span>
            <div>{{ $t('form.label.notification.alertMe') }}:</div>
            <div>
                <v-checkbox
                    v-for="(setting, index) in settings"
                    :key="index"
                    color="primary"
                    v-model="setting.IsSubscribed"
                    :label="setting.Description"
                    hide-details
                    v-on:change="onSettingChange($event, setting)"
                ></v-checkbox>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'stc-notification-settings',

    props: {
        showNotificationSettings: false,
    },

    computed: {
        show: {
            get: function () {
                return this.showNotificationSettings
            },
            set: function (value) {
                return value
            },
        },
        ...mapGetters(['selectedLanguage']),
    },

    data() {
        return {
            settings: [],
        }
    },

    created() {
        this.getNotifications()
    },

    methods: {
        close() {
            Events.$emit('show-notification-settings', false)
        },

        onSettingChange(checked, data) {
            if (checked) {
                this.$http.post(
                    `/GlobalNotification/Subscribe/${data.NotificationTypeID}`
                )
            } else {
                this.$http.delete(
                    `/GlobalNotification/UnSubscribe/${data.NotificationTypeID}`
                )
            }
        },

        async getNotifications() {
            const language =
                this.selectedLanguage.isoName === 'sv-SE' ? 'SV' : 'EN'
            const { data } = await this.$http.get(
                '/GlobalNotificationType/WEB/' + language
            )
            if (data) {
                this.settings = data
            }
        },
    },
}
</script>
<style scoped>
.el-dialog__body {
    background-color: red;
}
</style>